import React, { FunctionComponent } from 'react';
import { ButtonBase, Stack, SxProps, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import {
  StyledTableCell,
  StyledTableRow,
} from '../../../../../components/V2/Table/type1/TableStyles';
import { IUser } from '../../../../../store/UserSlice';

interface UserTableRowProps {
  userData: IUser;
  onView: () => void;
}

const actionButtonStyles: SxProps = {
  borderRadius: '8px',
  padding: '10px 12px 10px 12px',
  fontWeight: 600,
  fontSize: '14px',
  maxHeight: '36px',
  backgroundColor: '#006C9C',
  color: '#F8FAFC',
  width: 'fit-content',
};

const UserTableRow: FunctionComponent<UserTableRowProps> = ({
  userData,
  onView,
}) => {
  const navigate = useNavigate();

  const createdAt = moment(userData.createdAt);

  return (
    <StyledTableRow hover key={userData._id}>
      <StyledTableCell>
        <ButtonBase
          sx={{ textDecoration: 'underline' }}
          onClick={() =>
            navigate(`${process.env.PUBLIC_URL}/portal/users/${userData._id}`)
          }
        >
          {userData.username}
        </ButtonBase>
      </StyledTableCell>
      <StyledTableCell>
        <Typography fontSize="14px" fontWeight={500} color="#1E293B">
          {userData.role ? userData.role.name : '-'}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography fontSize="14px" fontWeight={500} color="#1E293B">
          {userData.firstname}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography fontSize="14px" fontWeight={500} color="#1E293B">
          {userData.lastname}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography fontSize="14px" fontWeight={500} color="#1E293B">
          {userData.phoneNumber}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography fontSize="14px" fontWeight={500} color="#1E293B">
          {userData.email}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Stack>
          <Typography fontSize="14px" fontWeight={500} color="#1E293B">
            {createdAt.format('ddd MMM DD YYYY')}
          </Typography>
          <Typography fontSize="12px" color="#94A3B8">
            {createdAt.format('hh:mm A')}
          </Typography>
        </Stack>
      </StyledTableCell>
      <StyledTableCell>
        <Stack>
          <ButtonBase sx={{ ...actionButtonStyles }} onClick={onView}>
            View
          </ButtonBase>
        </Stack>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default UserTableRow;
